// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".updateForm[data-v-36e1451e]{margin:auto;margin-top:8%}", ""]);
// Exports
module.exports = exports;
